<template>
  <div>
    <UITabHeader
      v-if="!hideTabHeader"
      :tabs="tabs"
      :active="activeTab"
      @tabClicked="setActiveTab"
    >
      <template v-slot:tabHeaderContent>
        <slot name="tabHeaderContent" />
      </template>
    </UITabHeader>
    <slot :name="activeTab" />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import type { PropType } from "vue";
import UITabHeader from "./tab-header.vue";

export type Tab = {
  id: string;
  label: string;
  showIndicator?: boolean;
};

export default defineComponent({
  components: {
    UITabHeader,
  },
  props: {
    tabs: {
      type: Array as PropType<Tab[]>,
      required: true,
    },
    defaultTabId: {
      type: String,
      required: false,
      default: null,
    },
    hideTabHeader: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["tabChanged"],
  setup(props, { emit }) {
    const activeTab = ref(props.defaultTabId ?? props.tabs[0].id);

    function setActiveTab(tab: string) {
      // Prevent multiple tab changes for the same tab
      if (activeTab.value === tab) return;

      activeTab.value = tab;
      emit("tabChanged", tab);
    }

    return {
      activeTab,
      setActiveTab,
    };
  },
});
</script>
